export class LoginModel {
    public username: string;
    public password: string;
    constructor(init?: Partial<LoginModel>) {
        Object.assign(this, init);
    }
}